module.exports = __webpack_public_path__ + "static/img/wheel-tips.ed16b762.png";